module.exports = __webpack_public_path__ + "media/images/amenities_icons/ar_equipment-a5774c01cfc5c81eee2c3d68eb3781f3.svg";